import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  CanLoad,
  Route,
  Router,
  RouterStateSnapshot,
  UrlSegment,
} from '@angular/router';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/map';
import { Observable, of } from 'rxjs';
import { AuthService } from './auth.service';
import { LoggerService } from '@user-interface/gcv-ui';
import { mergeMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate, CanLoad, CanActivateChild {
  constructor(public router: Router, public logger: LoggerService, private authService: AuthService) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.isUserLoggedIn('Activate');
  }

  canLoad(route: Route, segments: UrlSegment[]): boolean | Observable<boolean> | Promise<boolean> {
    return false;
  }

  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.isUserLoggedIn('ActivateChild');
  }

  private isUserLoggedIn(calleeMethod: 'Activate' | 'ActivateChild'): boolean | Observable<boolean> | Promise<boolean> {
    return this.authService.isUserLoggedIn().pipe(
      mergeMap((user: any) => {
        if (user) {
          this.logger.debug(`AuthGuard.can${calleeMethod}`);
          return this.authService.initLogin(user, true);
        } else {
          this.logger.debug(`AuthGuard.canNot${calleeMethod}`);
          this.router.navigate(['/login']);
          return of(false);
        }
      })
    );
  }
}
